<template >
    <!--Video Horizontal-->
    <div class="column" @click.prevent="changeSource(video)">
        <video-horizontal :video="video"></video-horizontal>
    </div>
</template>

<script>

import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCalendar } from '@fortawesome/free-solid-svg-icons'
import { faEye } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
Vue.component('font-awesome-icon', FontAwesomeIcon);
library.add(faCalendar,faEye)
import VideoHorizontal from './VideoHorizontal';
import VideoVertical from './VideoVertical';

export default {

  name: 'playlist-html',
  components:{
      VideoHorizontal,
      VideoVertical
  },
  props : {
    orientation:{
        type:String,
        default:'horizontal'
    },
    currentVideo: {
        type : Function
    },
    video:{},
  },
  data () {
      return {

      }

  },
    methods:{
        changeSource(video) {
            this.currentVideo(video);
        }
    },
}

</script>

<style scoped>
playlist-html{
    font-family: Arial, sans-serif;
}
    .column {
        position: relative;
        width: var(--video-horizontal-column-width,15%);
        margin: var(--video-horizontal-column-margin,2px);
        height: var(--video-horizontal-thumbnail-height,160px);
    }
  #list{
    width: 100%;
    background-color: var(--player-list-vertical-bg-color,#eff3f6);
    height:  var(--player-list-vertical-bg-color,#eff3f6)50vh !important;
    overflow-y: auto;
  }

  #idplaylist{
    background-color: #353f4c;
    width: 97.4%;
    height: 12%;
    font-weight: 700;
    font-size: 20px;
    left: -50%;
    padding-top: 25px;
    padding-left: 15px;
    color: #fff;
    display:flex

  }

  /* Clear floats after the columns */
  .row {
    display: var(--player-list-display,flex);
    flex-direction: var(--player-list-flex-direction,row);
    flex-wrap: var(--player-list-flex-wrap,wrap);
    justify-content: var(--player-list-flex-start,flex-start);
    overflow: var(--player-list-flex-overflow);
    height: var(--player-list-flex-height);
  }
  /* width */
  ::-webkit-scrollbar {
      width: var(--video-list-scrollbar-width,4px);
  }

  /* Track */
  ::-webkit-scrollbar-track {
      background: var(--video-list-scrollbar-bg-color,#f1f1f1);
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
      background: #888;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
      background: #555;
  }
</style>


// WEBPACK FOOTER //
// node_modules/component-video/src/components/Componentplay.vue